function Navigation() {
  this.init = function () {
    var companyAnalytics = $('.js--navigation-analytics');

    companyAnalytics.on("mouseover", function() {
      dataLayer.push({
        event: 'DLevent.marketingNavigation',
        marketingNavigation: 'Hover Company'
      });
    });
  };

  this.initAllReady = function () {};
}
